var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showingInvoice
    ? _c(
        "div",
        { attrs: { id: "invoiceDetail" } },
        [
          _c("AppBreadCrumb", {
            staticClass: "breadcrumb",
            attrs: { paths: _vm.breadcrumbPaths, select: true },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "invoice-detail-content" }, [
            _c("div", { staticClass: "invoice-summary" }, [
              _c("div", { staticClass: "summary-card" }, [
                _c("div", { staticClass: "summary-item" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("billing.period")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "value description" }, [
                    _vm._v(_vm._s(_vm.showingInvoice.period)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.showingInvoice.description
                  ? _c("div", { staticClass: "summary-item" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.description"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value description" }, [
                        _vm._v(_vm._s(_vm.showingInvoice.description)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-summary" }, [
                _c("div", { staticClass: "price-summary__head" }, [
                  _c("div", { staticClass: "summary-head__status" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "status",
                          _vm.isForecast
                            ? "forecast"
                            : _vm.showingInvoice.refund
                            ? "refund"
                            : _vm.showingInvoice.paid
                            ? "paid"
                            : "not-paid",
                        ],
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.isForecast
                                ? _vm.$t("message.pending")
                                : _vm.showingInvoice.refund
                                ? _vm.$t("message.refunded")
                                : _vm.showingInvoice.paid
                                ? _vm.$t("message.paid")
                                : _vm.$t("message.unpaid")
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "summary-head__period" },
                    [
                      _vm.isForecast
                        ? _c("a-switch", {
                            staticClass: "forecast-toggle",
                            attrs: {
                              "checked-children": _vm.$t(
                                "billing.invoiceForecastUntilToday"
                              ),
                              "un-checked-children": _vm.$t(
                                "billing.invoiceForecastMonthEnd"
                              ),
                            },
                            model: {
                              value: _vm.showingUntilToday,
                              callback: function ($$v) {
                                _vm.showingUntilToday = $$v
                              },
                              expression: "showingUntilToday",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price-summary__content" }, [
                  _c(
                    "div",
                    { staticClass: "price-item" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("billing.invoiceSubtotal"))),
                      ]),
                      _vm._v(" "),
                      _c("MoneyFormatter", {
                        attrs: {
                          price: _vm.showingInvoice.prices.price,
                          className: "total-price",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "price-item tax" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("billing.invoiceVatPercent", {
                              rate: _vm.vatRate,
                            })
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("MoneyFormatter", {
                        attrs: {
                          price: _vm.showingInvoice.prices.taxPrice,
                          className: "total-price",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "price-item total" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("billing.totalPrice"))),
                      ]),
                      _vm._v(" "),
                      _c("MoneyFormatter", {
                        attrs: {
                          price: _vm.showingInvoice.prices.totalPrice,
                          className: "total-price",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.showingInvoice.plans.length > 0
              ? _c(
                  "div",
                  { staticClass: "package-groups" },
                  _vm._l(_vm.showingInvoice.plans, function (planGroup, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "package-group" },
                      [
                        _c("div", { staticClass: "group-header" }, [
                          _c("h3", [_vm._v(_vm._s(planGroup.title))]),
                          _vm._v(" "),
                          planGroup.price > 0
                            ? _c(
                                "div",
                                { staticClass: "group-total" },
                                [
                                  _c("MoneyFormatter", {
                                    attrs: {
                                      price: planGroup.price,
                                      className: "total-price",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "package-items" },
                          _vm._l(planGroup.items, function (item, itemIndex) {
                            return _c(
                              "div",
                              { key: itemIndex, staticClass: "package-item" },
                              [
                                _c("div", { staticClass: "item-info" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.title) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "item-details" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getPackageDetails(item)
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  item.startDate
                                    ? _c(
                                        "div",
                                        { staticClass: "item-period" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.startDate) +
                                              " - " +
                                              _vm._s(item.endDate) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                item.price > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "item-price" },
                                      [
                                        _c("MoneyFormatter", {
                                          attrs: {
                                            price: item.price,
                                            className: "total-price",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }